import { useQuery } from '@tanstack/react-query';
import { fetchCartCheckoutMeta } from './apiFetchCartCheckoutMeta';
import { useDispatch } from 'react-redux';
import { ShoppingCartMetaOut } from '../../../../../store/api';
import { ErrorResponse } from '../../../../../store/notifications/actions';
import { typedFailure } from '../../../../checkout/utils/request-error';
import { PATH_CART } from '../../../../../store/constants';

const CART_CHECKOUT_META_QUERY = 'cartCheckoutMeta';

export const useCartCheckoutMeta = () => {
    const dispatch = useDispatch();

    return useQuery<ShoppingCartMetaOut, ErrorResponse>([CART_CHECKOUT_META_QUERY], () => fetchCartCheckoutMeta(), {
        onError: error => {
            dispatch(typedFailure(error, PATH_CART));
        }
    });
};
